import { createGlobalStyle } from 'styled-components';

export const Fonts = createGlobalStyle`
@font-face {
  font-family: "manrope";
  src: url("/assets/fonts/manrope-extrabold.ttf") format('truetype');
  font-weight: 800;
  font-display: swap;
}

@font-face {
  font-family: "manrope";
  src: url("/assets/fonts/manrope-bold.ttf") format('truetype');
  font-weight: 700;
  font-display: swap;
}

@font-face {
  font-family: "manrope";
  src: url("/assets/fonts/manrope-semibold.ttf") format('truetype');
  font-weight: 600;
  font-display: swap;
}

@font-face {
  font-family: "manrope";
  src: url("/assets/fonts/manrope-medium.ttf") format('truetype');
  font-weight: 500;
  font-display: swap;
}

@font-face {
  font-family: "manrope";
  src: url("/assets/fonts/manrope-regular.ttf") format('truetype');
  font-weight: 400;
  font-display: swap;
}

@font-face {
  font-family: "manrope";
  src: url("/assets/fonts/manrope-light.ttf") format('truetype');
  font-weight: 300;
  font-display: swap;
}

@font-face {
  font-family: "manrope";
  src: url("/assets/fonts/manrope-extralight.ttf") format('truetype');
  font-weight: 200;
  font-display: swap;
}

`;
